{
  "name": "sysbiz",
  "version": "4.1.16",
  "scripts": {
    "ng": "ng",
    "start": "ng serve --proxy-config proxy.config.json",
    "start:dev": "ng serve --build-target=sysbiz:development",
    "start:test": "ng serve --build-target=sysbiz:stable:test",
    "build": "node scripts/build-all.mjs",
    "build:development": "ng run sysbiz:development && systems-hide-version dist/development",
    "build:prodata-dev": "ng run sysbiz:prodata-dev && systems-hide-version dist/prodata-dev",
    "build:test": "ng run sysbiz:stable:test && systems-hide-version dist/test",
    "build:acodat": "ng run sysbiz:stable:acodat && systems-hide-version dist/acodat",
    "build:brandnamic": "ng run sysbiz:stable:brandnamic && systems-hide-version dist/brandnamic",
    "build:giacomuzzi": "ng run sysbiz:stable:giacomuzzi && systems-hide-version dist/giacomuzzi",
    "build:prodata": "ng run sysbiz:stable:prodata && systems-hide-version dist/prodata",
    "build:remags": "ng run sysbiz:stable:remags && systems-hide-version dist/remags",
    "build:rst": "ng run sysbiz:stable:rst && systems-hide-version dist/rst",
    "build:studiozeni": "ng run sysbiz:stable:studiozeni && systems-hide-version dist/studiozeni",
    "build:supra": "ng run sysbiz:stable:supra && systems-hide-version dist/supra",
    "build:systems": "ng run sysbiz:stable:systems && systems-hide-version dist/systems",
    "build:vps": "ng run sysbiz:stable:vps && systems-hide-version dist/vps",
    "build:cts": "ng run sysbiz:stable:cts && systems-hide-version dist/cts",
    "build:lts": "ng run sysbiz:stable:lts && systems-hide-version dist/lts",
    "build:rop": "ng run sysbiz:stable:rop && systems-hide-version dist/rop",
    "lint": "ng lint"
  },
  "private": true,
  "dependencies": {
    "@angular/animations": "^20.3.18",
    "@angular/cdk": "^19.2.18",
    "@angular/common": "^20.3.18",
    "@angular/compiler": "^20.3.18",
    "@angular/core": "^20.3.18",
    "@angular/forms": "^20.3.18",
    "@angular/localize": "^20.3.18",
    "@angular/platform-browser": "^20.3.18",
    "@angular/platform-browser-dynamic": "^20.3.18",
    "@angular/router": "^20.3.18",
    "@auth0/angular-jwt": "^5.2.0",
    "@fortawesome/fontawesome-pro": "^6.5.2",
    "@kolkov/angular-editor": "^2.1.0",
    "@ng-bootstrap/ng-bootstrap": "^19.0.0",
    "@ngx-translate/core": "^17.0.0",
    "@popperjs/core": "^2.11.8",
    "@systems/base": "^20.0.42",
    "bootstrap": "^5.3.3",
    "decimal.js": "^10.4.3",
    "jwt-decode": "^4.0.0",
    "marked": "^15.0.0",
    "mermaid": "^11.12.2",
    "ng2-pdf-viewer": "^10.4.0",
    "ngx-clipboard": "^16.0.0",
    "ngx-markdown": "^20.1.0",
    "ngx-translate-multi-http-loader": "^17.0.0",
    "pdf-lib": "^1.17.1",
    "pdfjs-dist": "^4.8.69",
    "rxjs": "~7.8.2",
    "signature_pad": "^5.0.3",
    "tslib": "^2.6.2",
    "uuid": "^11.1.1",
    "zone.js": "~0.15.1"
  },
  "devDependencies": {
    "@angular/build": "^20.3.31",
    "@angular/cli": "^20.3.31",
    "@angular/compiler-cli": "^20.3.26",
    "@types/node": "^20.12.10",
    "angular-eslint": "21.0.1",
    "chokidar": "^5.0.0",
    "eslint": "^9.39.1",
    "ts-node": "~10.9.1",
    "typescript": "~5.8.3",
    "typescript-eslint": "8.46.4",
    "vite": "^7.3.5"
  }
}
